<template>
  <div>
    <div class="input-row-2">
      <div>
        <div class="inputCard">
          <header>Main</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label>Header Type</label>
              <div class="w3-right-align">
                <select class="w3-select w3-border" v-model="state.siteData.header.type">
                  <option value="classic">Classic</option>
                  <option value="center">Center</option>
                  <option value="flat">Flat</option>
                  <option value="flat-top-bar">Flat Top Bar</option>
                  <option value="flat-top-bar-top-border">Flat Top Bar with Top Color</option>
                  <option value="flat-borders">Flat with Borders</option>
                  <option value="law">Law Firm</option>
                  <option value="floating-icons">Floating Icons</option>
                </select>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Header Logo Width (px)</label>
              <input class="w3-input w3-border" v-model="state.siteData.header.logoWidth" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Header Logo Height (px)</label>
              <input class="w3-input w3-border" v-model="state.siteData.header.logoHeight" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Header Sticky Top (px)</label>
              <input class="w3-input w3-border" v-model="state.siteData.header.stickyTop" />
            </div>
            <div class="cardRow w3-padding-8">
              <label>Page Headers Type</label>
              <select class="w3-select w3-border" v-model="state.siteData.pageHeader.type">
                <option value="modern-medium">Modern Medium</option>
                <option value="background-fixed">Background Fixed Image</option>
              </select>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Page Headers Background</label>
              <select class="w3-select w3-border" v-model="state.siteData.pageHeader.bgcolor">
                <option value="primary">Primary</option>
                <option value="dark">Dark</option>
                <option value="light">Light</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="inputCard">
          <header>Options</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label>Header Dark Mode</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.dark">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8" v-if="state.siteData.header.type === 'flat-top-bar' || state.siteData.header.type === 'flat-borders' || state.siteData.header.type === 'law'">
              <label>Header Top Colored</label>
              <div class="w3-right-align">
                <select class="w3-select w3-border" v-model="state.siteData.header.topColored">
                  <option value="none">Default</option>
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                  <option value="primary">Primary</option>
                  <option value="secondary">Secondary</option>
                </select>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Sticky Header Desktop</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.sticky">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Sticky Header Mobile</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.stickyMobile">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>stickyShrink Shrink Logo</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.stickyShrink">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Language Select</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.languageSelect">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>About Top Link</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.topAbout">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Contact Top Link</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.topContact">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Phone Top Link</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.topPhone">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Email Top Link</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.topEmail">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Search Top Link</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.topSearch">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Cart Top Link</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="state.siteData.header.topCart">
                  <span class="slider"></span>
                </label>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsSettingsHeader',
  data() {
    return {
      state: dataStore.state
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsSettingsHeader.vue